import React from 'react';
import {observer} from 'mobx-react';

import {sessionStorageRemoveItem} from 'core/utils.js';
import {SearchStoreContext} from 'core/stores/RootStore.js';
import {SEARCH_QUERY} from 'core/constants.js';
import SearchForm from 'search/components/SearchForm.js';
import Icon from 'core/components/Icon.js';

export default
@observer
class InsurerWidget extends React.Component {
    static contextType = SearchStoreContext;

    handleIframeInsurerWidget = (event) => {
        const iframeHeight = document.body.scrollHeight;
        const containerHeight = document.querySelector('.insurer-widget')
            .clientHeight;

        // the value of event.data could be either "mousedown", "click", "resize", or "orientationchange"
        // if event.data is "click" or "mousedown", update SearchStore
        // if event.data is "resize" or "orientationchange", notify the parent for new measurements
        const type = event.data;
        if (type) {
            this.context.iframeHandler(
                event.data,
                iframeHeight,
                containerHeight,
            );
        }
    };

    componentDidMount() {
        this.setRedesignStorageItems();
        window.addEventListener('message', this.handleIframeInsurerWidget);
    }

    componentWillUnmount() {
        // clean up the event listener when the component is unmounted
        window.removeEventListener('message', this.handleIframeInsurerWidget);
    }

    setRedesignStorageItems() {
        sessionStorageRemoveItem(SEARCH_QUERY);
    }

    renderDisclaimer() {
        const {disclaimer} = this.props;
        if (disclaimer) {
            return (
                <span className="insurer-widget__disclaimer">{`* ${disclaimer}`}</span>
            );
        }
        return null;
    }

    render() {
        const {placeholder} = this.props;
        return (
            <div className="insurer-widget">
                <SearchForm
                    isHealthWidget={true}
                    searchPlaceholder={placeholder}
                />
                {this.renderDisclaimer()}
                <footer>
                    <a
                        href="https://www.healthshare.com.au?clear"
                        target="_blank"
                    >
                        <p>Powered by</p>
                        <Icon name="HSLogo" />
                    </a>
                </footer>
            </div>
        );
    }
}
